import * as types from './types';

const INITIAL_STATE = {
  _data: [],
  groups: [],
  loading: true,
  loaded: false,
  saveing: false,
  roles: [],
  roleId: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.USER_ROLE_ACCESS_PAGE_DATA: {
      let { groups = [], roles = [{ Id: 0 }], data = [] } = payload;

      return {
        ...state,
        groups: groups,
        roles: roles,
        roleId: roles[0].Id,
        _data: data,
        loading: false,
      };
    }
    case types.USER_ROLE_ACCESS_SET_GROUPS: {
      let { groups = [], data = [] } = payload;

      return {
        ...state,
        groups: groups,
        _data: data,
      };
    }
    case types.USER_ROLE_ACCESS_CLEAR_GROUPS:
      return {
        ...state,
        groups: [],
      };
    case types.USER_ROLE_ACCESS_SET_ROLES:
      return {
        ...state,
        roles: payload,
      };
    case types.USER_ROLE_ACCESS_CLEAR_ROLES:
      return {
        ...state,
        roles: [],
      };
    case types.USER_ROLE_ACCESS_SET_ROLE_ID:
      return {
        ...state,
        roleId: payload,
      };
    case types.USER_ROLE_ACCESS_CLEAR_ROLE_ID:
      return {
        ...state,
        roleId: null,
      };
    case types.USER_ROLE_ACCESS_SET_LOADING:
      return {
        ...state,
        loading: !!payload,
      };
    case types.USER_ROLE_ACCESS_SET_SAVING:
      return {
        ...state,
        saving: true,
        loading: true,
      };
    case types.USER_ROLE_ACCESS_CLEAR_SAVING:
      return {
        ...state,
        saving: false,
        loading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/state/reducer.js